<template>
  <!-- exhibition-business .eb -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">推广</BreadcrumbItem>
          <BreadcrumbItem>商机</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
        <Input placeholder="请输入关键字" style="width:230px;margin-top:20px;">
          <Icon type="ios-search" slot="suffix" />
        </Input>
        <!-- <p class="header-tool-text" v-if="String(showTabs) === '1'">共发布&nbsp;{{num}}&nbsp;条商机</p>
        <p class="header-tool-text" v-if="String(showTabs) === '2'">共计有&nbsp;{{num}}&nbsp;人发起了申请</p> -->
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="exportOrder()">
          <i class="icon iconfont icon-downLoad2" style="font-size:20px;"></i>
          <span style="margin-left:5px;">名单下载</span>
        </div>
      </div>
      <!-- <div v-show="String(showTabs) === '1'" class="header-tool-box">
        <div class="htb-item" @click="add('exhibitionBusinessMy')">
          <span class="htb-add">+</span>
          <span>发布商机</span>
        </div>
      </div>
      <div v-show="String(showTabs) === '2'" class="header-tool-box">
        <div class="htb-item" @click="exportInfo('exhibitionBusinessMatch')">
          <span>
            <i class="icon iconfont icon-shangchuan"></i>
          </span>
          <span>导出</span>
        </div>
      </div> -->
      <!-- <div v-show="String(showTabs) === '3'" class="header-tool-box" @click="add('successCase')">
        <div class="htb-item">
          <span class="htb-add">+</span>
          <span>新增案例</span>
        </div>
      </div> -->
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="全部" name="1">
          <exhibitionAllbusiness />
          <!-- <exhibitionBusinessMy
            ref="exhibitionBusinessMy"
            v-if="String(showTabs) === '1'"
            @showNum="setNume"
          /> -->
        </TabPane>
        <TabPane label="已标记" name="2">
          <exhibitionBusinessMatch
            ref="exhibitionBusinessMatch"
            v-if="String(showTabs) === '2'"
            @showNum="setNume"
          />
        </TabPane>
        <!-- <TabPane label="商机拓展" name="3">
          <exhibitionBusinessExpand ref="exhibitionBusinessExpand" v-if="String(showTabs) === '3'" />
        </TabPane>-->
      </Tabs>
    </div>
    <Contact />
  </div>
</template>

<script>
import exhibitionAllbusiness from "./components/all-business.vue";
import exhibitionBusinessExpand from "./subpages/exhibition-business-expand/exhibition-business-expand.vue";
import exhibitionBusinessMy from "./subpages/exhibition-business-my/exhibition-business-my.vue";
import exhibitionBusinessMatch from "./subpages/exhibition-business-match/exhibition-business-match.vue";
import Contact from "@components/Contact/Contact";
import { mapGetters } from "vuex";

export default {
  name: "exhibition-business",
  data() {
    return {
      flag: true,
      showTabs: "1",
      num: 0,
      refName: "",
    };
  },
  components: {
    exhibitionAllbusiness,

    exhibitionBusinessMy,
    exhibitionBusinessMatch,
    exhibitionBusinessExpand,

    Contact,
  },
  created() {
    this.changeTab();
  },
  computed: {
    ...mapGetters({ 
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$route.query;
    }
  },
  methods: {
    changeTab() {
      if (this.query && this.query.type && this.query.type === "match") {
        this.showTabs = "2";
        this.flag = false;
      }
      if (this.query && this.query.type && this.query.type === "expand") {
        this.showTabs = "3";
        this.flag = false;
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=my`);
        this.flag = true;
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=match`);
        this.flag = false;
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=expand`);
        this.flag = false;
      }
    },
    add(name) {
      this.$refs[name].showAdd();
    },
    exportInfo(name) {
      // 导出数据
      this.$refs[name].exportInfo();
    },
    setNume(num) {
      this.num = num;
    },
    exportOrder() { 
    }
  }
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
